/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APISharepoint } from './APISharepoint';
import {
    APISharepointFromJSON,
    APISharepointFromJSONTyped,
    APISharepointToJSON,
} from './APISharepoint';

/**
 * 
 * @export
 * @interface APIPaginatedSharepointList
 */
export interface APIPaginatedSharepointList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedSharepointList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedSharepointList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedSharepointList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APISharepoint>}
     * @memberof APIPaginatedSharepointList
     */
    results: Array<APISharepoint>;
}

/**
 * Check if a given object implements the APIPaginatedSharepointList interface.
 */
export function instanceOfAPIPaginatedSharepointList(value: object): value is APIPaginatedSharepointList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedSharepointListFromJSON(json: any): APIPaginatedSharepointList {
    return APIPaginatedSharepointListFromJSONTyped(json, false);
}

export function APIPaginatedSharepointListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedSharepointList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APISharepointFromJSON)),
    };
}

export function APIPaginatedSharepointListToJSON(value?: APIPaginatedSharepointList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APISharepointToJSON)),
    };
}

